export const EN = { code: 'en', language: 'English' }
export const ZHCN = { code: 'cn', language: '简体中文' }

export const allLanguages = [
  ZHCN
]
